/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./testimonial.component.less.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./testimonial.component";
var styles_TestimonialComponent = [i0.styles];
var RenderType_TestimonialComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_TestimonialComponent, data: {} });
export { RenderType_TestimonialComponent as RenderType_TestimonialComponent };
export function View_TestimonialComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "div", [["class", "wrapper"]], null, null, null, null, null)), i1.ɵncd(null, 0)], null, null); }
export function View_TestimonialComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-testimonial", [], null, null, null, View_TestimonialComponent_0, RenderType_TestimonialComponent)), i1.ɵdid(1, 49152, null, 0, i2.TestimonialComponent, [], null, null)], null, null); }
var TestimonialComponentNgFactory = i1.ɵccf("app-testimonial", i2.TestimonialComponent, View_TestimonialComponent_Host_0, {}, {}, ["*"]);
export { TestimonialComponentNgFactory as TestimonialComponentNgFactory };
